export { errorMessage, RamoMark } from '../../customers/common/customer-common'

export const DUE_DATES_BACK_PATH = '/configuracion'
export const DUE_DATES_HELP_URL = 'https://appdalala.blogspot.com/2022/05/configuracion-de-vencimientos.html'
